import { BaseService } from './base.service';
import { FamilyStats, MemberStats, UpdateMemberStatsDto } from '@/types/familyStats';

class FamilyStatsService extends BaseService {
  constructor() {
    super('/family-stats');
  }

  /**
   * Get family statistics including member-level stats
   * Uses the logged-in user's family context
   * @returns Family statistics with all member stats
   */
  async getFamilyStats(): Promise<FamilyStats> {
    return await this.get<FamilyStats>('');
  }

  /**
   * Get statistics for a specific member within a family
   * Uses the logged-in user's family context
   * @param memberId - The member ID
   * @returns Member statistics
   */
  async getMemberStats(memberId: string): Promise<MemberStats> {
    return await this.get<MemberStats>(`/member/${memberId}`);
  }

  /**
   * Update member statistics
   * Uses the logged-in user's family context
   * @param updateDto - The update data
   * @returns Updated family statistics
   */
  async updateMemberStats(updateDto: UpdateMemberStatsDto): Promise<FamilyStats> {
    return await this.put<FamilyStats>('/member', updateDto);
  }

  /**
   * Mark emergency card as complete for a member (backup call from frontend)
   * Uses the logged-in user's family context
   * @param memberId - The member ID
   * @returns Updated family statistics
   */
  async markEmergencyCardComplete(memberId: string): Promise<FamilyStats> {
    return await this.put<FamilyStats>('/member', {
      memberId,
      emergencyCardComplete: true,
    });
  }
}

export default new FamilyStatsService();
